import cx from 'classnames'
import * as _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { Container, Tab, Tabs } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import Select from 'react-select'

import downarrowblue from '@/assets/New-images/dropdown-arow-blue.svg'

import { MuiButton } from '@/components/base/MuiButton'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import MoveSelectedModal from '@/components/UI/KnowledgeDatatableComponent/MoveSelectedModal'
import Loading from '@/components/UI/Loading/Loading'
import PDFViewer from '@/components/UI/PDFViewer/PDFViewer'
import PermissionWrapper from '@/components/UI/PermissionWrapper/PermissionWrapper'
import ProgressSteps from '@/components/UI/ProgressSteps/ProgressSteps'
import { BUILD_FINAL } from '@/config/index'
import { useAsyncHandler } from '@/hooks/useAsyncHandler'
import { HelperService } from '@/services/helper.service'
import { getStickerSets } from '@/store/common/actions'
import {
  bulkAssignModules,
  getDocumentFromID,
  getSectionsBasedOnDocumentId,
  resetAnswersScreen,
  saveQuestionsAndAnswers,
} from '@/store/knowledge/actions'
import {
  getUserDocuments,
  isKnowledgeCreating,
} from '@/store/knowledge/selector'
import { DocumentPreview } from '../../Knowledge/GenerateAnswers/partials/DocumentPreview'
import QAnsAListSummarised from '../../Knowledge/GenerateQuestionsAnswers/partials/QAnsAListSummarised'
import GenerateKnowledgePopup from './Popups/GenerateKnowledgePopup'
import SmartQuizPopup from './Popups/SmartQuizPopup'

const helper = new HelperService()
const GenerateQna = (props: any) => {
  const { t } = useTranslation('translation')
  const history: any = useHistory()
  const query = new URLSearchParams(history.location.search)
  const [preview, setpreview] = React.useState(false)
  const [answerData, setAnswerData] = React.useState(null)
  const [answerGenerationProcessing, SetAnswerGenerationProcessing] =
    useState(false)
  let defaultActiveKey = props.manageDocument ? 'qnas' : 'questions'

  const [activeTab, setActiveTab] = useState(defaultActiveKey)
  const [loading, setLoading] = useState(false)
  const [generatedQuestions, setGeneratedQuestions] = useState([])
  const [updatedQuestions, setUpdatedQuestions] = useState([])
  const dispatch = useDispatch()
  const userDocuments = useSelector(getUserDocuments)
  const knowledgeCreating = useSelector(isKnowledgeCreating)
  const [sections, setSections] = useState([])
  const [selectedSection, setSelectedSection] = useState(null)
  const [hasSectionSaved, setHasSectionSaved] = useState([])
  const useLocatio = useLocation()
  const [modalShow, setModalShow] = useState(false)
  const [urlMap, setUrlMap] = useState(null)
  const [selectedDocument, setSelectedDocument] = useState(null)
  const [documents, setDocuments] = useState([])
  const [selectedDocumentIndex, setSelectedDocumentIndex] = useState(0)
  const [documentSectionData, setDocumentSectionData] = useState(null)
  const [paramsQueIds, setParamsQueIds] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [addNewQuestionAnswer, setAddNewQuestionAnswer] = useState({
    question: '',
    answer: '',
    sort_order: 0,
    show: false,
  })

  const [groupId, setGroupId] = useState(query.get('group') || '')
  const [showSmartQuizModal, setShowSmartQuizModal] = useState(false)

  // Hook to prevent double-clicks on "Save to Knowledge Base" button (multiple documents)
  const { run: handleSaveToKnowledgeBase, loading: isSaving } = useAsyncHandler(
    async () => {
      await saveSectionDetails(selectedDocumentIndex + 1, true)
    },
  )

  // Hook for single document case - opens modal synchronously
  const { run: handleOpenSaveModal, loading: isOpeningModal } = useAsyncHandler(
    async () => {
      setModalShow(true)
    },
  )

  // Hook for previous document navigation (multiple documents)
  const { run: handlePreviousDocument, loading: isNavigatingPrev } =
    useAsyncHandler(async () => {
      if (documents[selectedDocumentIndex - 1]) {
        await saveSectionDetails(selectedDocumentIndex - 1)
      }
    })

  // Hook for skip to next document (multiple documents)
  const { run: handleSkipToNext, loading: isSkipping } = useAsyncHandler(
    async () => {
      if (documents[selectedDocumentIndex + 1]) {
        skipDocument()
      }
    },
  )

  useEffect(() => {
    setGroupId(
      history &&
        history.location &&
        history.location.state &&
        history.location.state.group
        ? history.location.state.group
        : query.get('group'),
    )
  }, [])

  useEffect(() => {
    setpreview(false)
    setHasSectionSaved([])
    if (userDocuments.length === 0) {
      dispatch(resetAnswersScreen())
    }
    if (!useLocatio.search) {
      history.goBack()
    }

    const query = new URLSearchParams(useLocatio.search)
    const paramsUrl = query.get('question').split(',')
    setParamsQueIds(paramsUrl)

    if (paramsUrl.length === 0) {
      history.goBack()
      return
    }

    generateQuestionsAndAnswersBasedOnDocumentFn()

    dispatch(getStickerSets())
  }, [])

  const generateQuestionsAndAnswersBasedOnDocumentFn = async () => {
    const query = new URLSearchParams(useLocatio.search)
    const params = query.get('question').split(',')

    try {
      const Documents = []
      let index = 0
      for await (const document of params) {
        const fetchedDocument: any = await dispatch(getDocumentFromID(document))
        Documents.push({
          ...fetchedDocument,
          documentIndex: index,
          label: fetchedDocument.name,
          value: fetchedDocument._id,
        })
        index++
      }

      setDocuments([...Documents])
      paginateDocuments(Documents, 0)
    } catch (error) {}
  }

  const paginateDocuments = async (documents: any[] = [], index: number) => {
    let docuData: any = { ...documentSectionData }
    if (
      !documentSectionData ||
      (docuData && !docuData[documents[index]._id]) ||
      (docuData &&
        docuData[documents[index]._id] &&
        !docuData[documents[index]._id].hasOwnProperty('hasApiCalled'))
    ) {
      const sectionResponse: any = await dispatch(
        getSectionsBasedOnDocumentId([documents[index]._id]),
      )

      setSections([...sectionResponse])
      setSelectedSection(sectionResponse.length > 0 ? sectionResponse[0] : null)
      setDocumentSection(sectionResponse, documents[index]._id)
    }
    setGeneratedQuestions([
      {
        ...documents[index],
        qnas: [],
      },
    ])
    setUpdatedQuestions([
      {
        ...documents[index],
        qnas: [],
      },
    ])

    setSelectedDocument(documents[index])
    setSelectedDocumentIndex(index)
  }

  const setDocumentSection = async (
    fetchedSections: any[],
    questionId: string,
  ) => {
    const temp: { [id: string]: any } = {}

    temp[questionId] = {
      ...temp[questionId],
    }

    if (fetchedSections.length > 0) {
      temp[questionId].hasApiCalled = true
      temp[questionId].questions = []
      await setDocumentSectionData({ ...documentSectionData, ...temp })
      return
    }
  }

  const saveKnowledge = async (
    selectedOption: string,
    createButtons: boolean,
    queType: any[] = [],
  ) => {
    if (!selectedOption) {
      helper.showToaster('Please choose a module before saving.')
      return
    }
    setShowSmartQuizModal(false)
    try {
      const query = new URLSearchParams(useLocatio.search)
      const type = query.get('type')
      await setLoading(true)

      await dispatch(
        saveQuestionsAndAnswers(
          updatedQuestions,
          createButtons,
          true,
          selectedOption,
          queType,
          queType.length > 0,
        ),
      )
      if (selectedOption) {
        await dispatch(
          bulkAssignModules(
            selectedOption,
            // paramsQueIds.length > 0 ? paramsQueIds : [params.questionId],
            paramsQueIds,
            'document',
            false,
          ),
        )
      }
      await setLoading(false)
      const sectionSaved = [...hasSectionSaved]
      if (selectedSection) {
        sectionSaved.push(selectedSection.value)
      }
      setHasSectionSaved([...sectionSaved])
      if (sections.length === 1) {
        if (!documents[selectedDocumentIndex + 1]) {
          history.push(`${BUILD_FINAL}?group=${groupId}&type=${type}`)
        } else {
          await saveSectionDetails(selectedDocumentIndex + 1)
        }
      }
    } catch (error: any) {
      setModalShow(false)
      await setLoading(false)
    }
    return
  }

  const updatedAnswersHandler = (data: any) => {
    const oldQuestions = [...generatedQuestions]
    const document = oldQuestions.find(d => d._id === data.documentId)
    document.qas =
      data.qas && data.qas.length > 0
        ? _.orderBy([...data.qas], 'sort_order', 'asc')
        : []
    document.keywordsLoading = data.keywordsLoading
      ? data.keywordsLoading
      : false
    document.qasFetchError = data.qasFetchError ? data.qasFetchError : false
    document.last_offset = data.last_offset ? data.last_offset : 0
    document.retryExecution = data.retryExecution ? data.retryExecution : false
    setUpdatedQuestions([...oldQuestions])

    const temp = { ...documentSectionData }
    temp[data.documentId].questions = [...document.qas]
    setDocumentSectionData(temp)

    const keywordsLoading = oldQuestions.filter(
      (document: any) =>
        document.qas && document.qas.length === 0 && !document.qasFetchError,
    )
    SetAnswerGenerationProcessing(keywordsLoading.length > 0 ? true : false)
  }

  const previewToggleHandler = async (answerData: any) => {
    if (answerData.hasOwnProperty('keyword')) {
      await setAnswerData({
        ...answerData,
      })
    }
    setpreview(!preview)
  }

  const tabsChangeHandler = (e: any) => {
    setActiveTab(e)
  }

  const [createButtons, setCreateButtons] = useState(false)
  const [selectedOption, setSelectedOption] = useState(null)
  const confirmCategoryUpdateHandler = async (
    selectedOption: any,
    createButtons: boolean = false,
  ) => {
    try {
      if (selectedOption) {
        await setSelectedOption(selectedOption)
      }
      if (createButtons) {
        await setCreateButtons(createButtons)
      }
      if (selectedOption) {
        await setModalShow(false)
        await setShowSmartQuizModal(true)
      }
    } catch (error: any) {}
  }

  const saveSectionDetails = async (
    index: number,
    saveToKnowledgeBase: boolean = false,
  ) => {
    if (!selectedDocument || !selectedDocument.value) {
      console.log('-- track --', selectedDocument)
      return
    }

    try {
      setLoading(true)
      if (saveToKnowledgeBase) {
        await setModalShow(true)
      } else {
        await paginateDocuments(documents, index)
        setLoading(false)
      }
    } catch (error: any) {
      setLoading(false)
    }
  }

  const skipDocument = () => {
    const docuData = { ...documentSectionData }
    if (docuData[documents[selectedDocumentIndex]._id].questions.length >= 1) {
      setShowModal(true)
    } else {
      saveSectionDetails(selectedDocumentIndex + 1)
    }
  }

  const addMoreQuestionHandler = (e: any, documentId: any) => {
    e.preventDefault()
    const Qnas = [...documentSectionData[documentId].questions]
    setAddNewQuestionAnswer({
      ...addNewQuestionAnswer,
      show: true,
    })
    const oldAnswers: any[] = [...Qnas]
    oldAnswers.unshift({
      question: addNewQuestionAnswer.question,
      answer: addNewQuestionAnswer.answer,
      sort_order: 0,
      newlyAdded: true,
      hasEditMode: true,
    })
    updatedAnswersHandler({
      documentId: documentId,
      qas: oldAnswers,
    })
  }

  const generateSmartQuiz = async (queType: any, hide: boolean = false) => {
    if (hide) {
      setShowSmartQuizModal(false)
    }
    await saveKnowledge(selectedOption, createButtons, !hide && queType)
  }

  return (
    <>
      {loading && <Loading />}
      <aside
        className={cx({
          'notification-wrap': true,
          open: preview,
        })}
      >
        <DocumentPreview
          answerData={answerData}
          preview={preview}
          previewToggleHandler={previewToggleHandler}
        />
      </aside>

      <MoveSelectedModal
        show={modalShow}
        onHide={() => {
          setLoading(false)
          setModalShow(false)
        }}
        confirmCategoryUpdate={confirmCategoryUpdateHandler}
        summarisedView
        groupId={groupId}
      />

      <SmartQuizPopup
        show={showSmartQuizModal}
        onHide={() => setShowSmartQuizModal(false)}
        onProceed={generateSmartQuiz}
      />

      {showModal && (
        <GenerateKnowledgePopup
          show
          onHide={() => {
            setShowModal(false)
          }}
          onProceed={() => {
            if (!documents[selectedDocumentIndex + 1]) {
              history.push(BUILD_FINAL)
            } else {
              saveSectionDetails(selectedDocumentIndex + 1)
            }
            setShowModal(false)
          }}
        />
      )}

      <section
        className={cx({
          'page-mid-wraper page-mid-wraper-build-v2 pb-0': true,
          'h-without-foter': activeTab === 'qnas',
          'knowledge-detailby-id': props && props.hideHeaders,
        })}
      >
        <Container>
          <ChildPageHeader
            title={t('Generate Knowledge from Document(s)')}
            subTitle={t(
              'Create question and answer pairs for use in quizzes or tutoring flows',
            )}
            slot={{
              action: (
                <PermissionWrapper>
                  {paramsQueIds.length > 1 ? (
                    <div className="d-flex align-items-center">
                      {selectedDocumentIndex > 0 && (
                        <MuiButton
                          variant="outlined"
                          color="primary"
                          className="mr-3 font-weight-bold"
                          onClick={handlePreviousDocument}
                          disabled={
                            isNavigatingPrev ||
                            !documents[selectedDocumentIndex - 1]
                          }
                        >
                          {t('Previous Document')}
                        </MuiButton>
                      )}
                      <MuiButton
                        variant="outlined"
                        color="primary"
                        className="mr-3 font-weight-bold"
                        onClick={handleSkipToNext}
                        disabled={
                          isSkipping || !documents[selectedDocumentIndex + 1]
                        }
                      >
                        {t('Skip to Next Document')}
                      </MuiButton>
                      <MuiButton
                        variant="contained"
                        color="primary"
                        className="mr-3"
                        onClick={handleSaveToKnowledgeBase}
                        disabled={
                          isSaving ||
                          knowledgeCreating ||
                          answerGenerationProcessing ||
                          (documentSectionData &&
                            selectedDocument &&
                            !documentSectionData[selectedDocument._id].questions
                              .length)
                        }
                      >
                        {t('Save to Knowledge Base')}
                      </MuiButton>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center">
                      <MuiButton
                        variant="outlined"
                        color="primary"
                        className="third-step mr-3"
                        onClick={() => {
                          history.push(BUILD_FINAL)
                        }}
                        disabled={
                          knowledgeCreating || answerGenerationProcessing
                        }
                      >
                        {t('Skip This Step')}
                      </MuiButton>
                      <MuiButton
                        variant="contained"
                        color="primary"
                        className="third-step"
                        onClick={handleOpenSaveModal}
                        disabled={
                          isOpeningModal ||
                          knowledgeCreating ||
                          answerGenerationProcessing ||
                          (documentSectionData &&
                            selectedDocument &&
                            !documentSectionData[selectedDocument._id].questions
                              .length)
                        }
                      >
                        {t('Save to Knowledge Base')}
                      </MuiButton>
                    </div>
                  )}
                </PermissionWrapper>
              ),
            }}
          />

          <Tabs
            defaultActiveKey={defaultActiveKey}
            onSelect={tabsChangeHandler}
            activeKey={activeTab}
          >
            <Tab eventKey="questions" title={t('Generate Knowledge')}>
              <div className="pdf-section-wrapper">
                <div>
                  {generatedQuestions.map((document: any, index: number) => {
                    return (
                      <div
                        className="document-section-wrapper row"
                        key={document._id}
                      >
                        <div className="col-md-5">
                          {paramsQueIds.length > 1 && (
                            <div className="font-16 font-weight-bold clr-black mt-md-0">
                              <Select
                                className="select-target px-0 select-blue shadow-none"
                                classNamePrefix="select-target-prefix"
                                value={selectedDocument}
                                components={{
                                  DropdownIndicator: () => (
                                    <img src={downarrowblue} alt="" />
                                  ),
                                  IndicatorSeparator: () => null,
                                  ClearIndicator: () => null,
                                }}
                                onChange={e => {
                                  saveSectionDetails(e.documentIndex)
                                }}
                                placeholder={t('Document')}
                                options={documents}
                              />
                            </div>
                          )}
                          {/* Instead of pdf viewer we have to show all text */}
                          <div className="mt-3">
                            <PDFViewer
                              setUrlMapForParent={setUrlMap}
                              documentId={document._id}
                            />
                          </div>
                        </div>

                        <div className="col-md-7">
                          <div key={document._id} title={document.name}>
                            <QAnsAListSummarised
                              key={document._id}
                              index={index}
                              isSummarised
                              {...document}
                              setAnswerData={previewToggleHandler}
                              documentLength={userDocuments.length}
                              updatedAnswersHandler={updatedAnswersHandler}
                              section={selectedSection}
                              setAnswerGenerationProcessing={
                                SetAnswerGenerationProcessing
                              }
                              qas={[
                                ...documentSectionData[document._id]?.questions,
                              ]}
                              addMoreQuestionHandler={addMoreQuestionHandler}
                              buildKnowledge={true}
                            />
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </Tab>
          </Tabs>

          <footer>
            <Container>
              <div className="d-flex align-items-center justify-content-end px-2"></div>
            </Container>
            <ProgressSteps currentStep={4} steps={4} />
          </footer>
        </Container>
      </section>
    </>
  )
}

export default GenerateQna
